import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MenuCadastroRequest, MenuSistema } from '../../../../../models/menuItens.model';

interface MetadataEntry { key: string; value: string; }
import { MenuService } from '../../../../../services/menu.service';

@Component({
  selector: 'app-menu-manutencao',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './menu-manutencao.component.html',
  styleUrls: ['./menu-manutencao.component.css'],
})
export class MenuManutencaoComponent implements OnInit {
  menu: MenuCadastroRequest = {
    title: '',
    posicao: 1,
    slug: '',
    parentId: null,
    metadata: {}
  };

  metadataEntries: MetadataEntry[] = [];
  slugManuallyEdited = false;

  menus: MenuSistema[] = [];
  isEditMode = false;
  isLoading = false;
  private idMenu: number | null = null;
  private cdr = inject(ChangeDetectorRef);

  constructor(
    private menuService: MenuService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      this.isEditMode = true;
      this.idMenu = +id;
      this.isLoading = true;

      forkJoin({
        menus: this.menuService.getMenus(),
        menu: this.menuService.getMenu(+id)
      }).subscribe({
        next: ({ menus, menu }) => {
          this.menus = menus;
          this.menu = {
            title: menu.title,
            posicao: menu.posicao,
            slug: menu.slug,
            parentId: menu.parentId,
            metadata: {}
          };
          this.metadataEntries = Object.entries(menu.metadata ?? {}).map(([key, value]) => ({ key, value }));
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.isLoading = false;
          const mensagem = error?.error?.message ?? 'Erro ao carregar menu.';
          this.toastr.error(mensagem);
          this.router.navigate(['/home', 'sistema-menu']);
        }
      });
    } else {
      this.menuService.getMenus().subscribe({
        next: (data) => this.menus = data,
        error: () => {}
      });
    }
  }

  onTitleChange(title: string): void {
    if (!this.isEditMode && !this.slugManuallyEdited) {
      this.menu.slug = title.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      this.cdr.detectChanges();
    }
  }

  addMetadataEntry(): void {
    this.metadataEntries.push({ key: '', value: '' });
    this.cdr.detectChanges();
  }

  removeMetadataEntry(index: number): void {
    this.metadataEntries.splice(index, 1);
    this.cdr.detectChanges();
  }

  private buildMetadataObject(): { [key: string]: string } {
    return this.metadataEntries.reduce((acc, entry) => {
      if (entry.key.trim()) {
        acc[entry.key.trim()] = entry.value;
      }
      return acc;
    }, {} as { [key: string]: string });
  }

  save(): void {
    if (!this.menu.slug?.trim()) {
      this.toastr.error('Slug é obrigatório.');
      return;
    }

    const payload: MenuCadastroRequest = {
      ...this.menu,
      parentId: this.menu.parentId ? Number(this.menu.parentId) : null,
      metadata: this.buildMetadataObject()
    };

    if (this.isEditMode && this.idMenu) {
      this.menuService.updateMenu(this.idMenu, payload).subscribe({
        next: () => {
          this.toastr.success('Menu atualizado com sucesso!');
          this.router.navigate(['/home', 'sistema-menu']);
        },
        error: (error) => {
          const mensagem = error?.error?.message ?? 'Erro ao atualizar menu.';
          this.toastr.error(mensagem);
        }
      });
      return;
    }

    this.menuService.createMenu(payload).subscribe({
      next: () => {
        this.toastr.success('Menu cadastrado com sucesso!');
        this.router.navigate(['/home', 'sistema-menu']);
      },
      error: (error) => {
        const mensagem = error?.error?.message ?? 'Erro ao cadastrar menu.';
        this.toastr.error(mensagem);
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/home', 'sistema-menu']);
  }

}
